class StickyATC {
  constructor(el) {
    this.el = el;
    this.sectionId = el.dataset.sectionId;
    this.formId = el.dataset.formId;
    this.btn = el.querySelector('.sticky-atc__btn');
    this.originalBtn = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
    this.variantSelect = el.querySelector('.sticky-atc__variant-select');
    this.qtyInput = el.querySelector('.sticky-atc__qty-input');
    this.qtyMinus = el.querySelector('.sticky-atc__qty-minus');
    this.qtyPlus = el.querySelector('.sticky-atc__qty-plus');
    this.ticking = false;
    this._adding = false; // guard: prevent observer interfering during AJAX

    this._init();
  }

  _getVariantId() {
    // 1. Sticky variant select (multi-variant products)
    if (this.variantSelect && this.variantSelect.value) {
      return this.variantSelect.value;
    }
    // 2. Main form hidden input (single-variant or fallback)
    const mainForm = document.getElementById(this.formId);
    if (mainForm) {
      const hidden = mainForm.querySelector('[name="id"]');
      if (hidden && hidden.value) return hidden.value;
    }
    return null;
  }

  _init() {
    if (!this.originalBtn) return;

    // Quantity buttons
    if (this.qtyMinus && this.qtyInput) {
      this.qtyMinus.addEventListener('click', () => {
        const current = parseInt(this.qtyInput.value, 10) || 1;
        if (current > 1) this.qtyInput.value = current - 1;
      });
    }

    if (this.qtyPlus && this.qtyInput) {
      this.qtyPlus.addEventListener('click', () => {
        const current = parseInt(this.qtyInput.value, 10) || 1;
        this.qtyInput.value = current + 1;
      });
    }

    // Variant select — sync to main form hidden input and trigger change
    if (this.variantSelect) {
      this.variantSelect.addEventListener('change', () => {
        const variantId = this.variantSelect.value;
        const mainForm = document.getElementById(this.formId);
        if (mainForm) {
          const hiddenInput = mainForm.querySelector('[name="id"]');
          if (hiddenInput) {
            hiddenInput.value = variantId;
            hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      });

      // Keep sticky select in sync when main form variant changes
      const mainForm = document.getElementById(this.formId);
      if (mainForm) {
        const hiddenInput = mainForm.querySelector('[name="id"]');
        if (hiddenInput) {
          hiddenInput.addEventListener('change', () => {
            if (this.variantSelect.value !== hiddenInput.value) {
              this.variantSelect.value = hiddenInput.value;
            }
          });
        }
      }
    }

    // Add to cart via AJAX — reads qty and variant directly from sticky bar
    this.btn.addEventListener('click', () => {
      if (this.btn.disabled || this._adding) return;

      // 1. Quantity — from sticky qty input
      const qty = parseInt(this.qtyInput ? this.qtyInput.value : 1, 10) || 1;

      // 2. Variant — via helper (sticky select → main form hidden → fail)
      const variantId = this._getVariantId();
      if (!variantId) return;

      // 3. Lock button & pause observer so it can't fight our feedback
      this._adding = true;
      this.btn.disabled = true;
      const btnSpan = this.btn.querySelector('span');
      const originalLabel = btnSpan ? btnSpan.textContent.trim() : '';
      if (btnSpan) btnSpan.textContent = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: qty })
      })
        .then(res => { if (!res.ok) throw new Error('Cart error'); return res.json(); })
        .then(() => fetch('/?sections=header'))
        .then(res => res.json())
        .then(data => {
          // Update cart bubble with real total quantity
          const html = data['sections--header'] || data['header'] || '';
          if (html) {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const newBubble = doc.querySelector('#cart-icon-bubble');
            const curBubble = document.querySelector('#cart-icon-bubble');
            if (newBubble && curBubble) curBubble.innerHTML = newBubble.innerHTML;
          }
          if (btnSpan) btnSpan.textContent = 'Added!';
          setTimeout(() => {
            this._adding = false;
            if (btnSpan) btnSpan.textContent = originalLabel;
            this.btn.disabled = this.originalBtn.disabled;
          }, 2000);
        })
        .catch(() => {
          this._adding = false;
          if (btnSpan) btnSpan.textContent = originalLabel;
          this.btn.disabled = this.originalBtn.disabled;
        });
    });

    // Sync disabled state and label with original button — skipped while AJAX is in flight
    const observer = new MutationObserver(() => {
      if (this._adding) return; // don't overwrite our "Adding..." / "Added!" feedback
      this.btn.disabled = this.originalBtn.disabled;
      const span = this.btn.querySelector('span');
      const originalSpan = this.originalBtn.querySelector('span');
      if (span && originalSpan) {
        span.textContent = originalSpan.textContent;
      }
    });
    observer.observe(this.originalBtn, { attributes: true, subtree: true, characterData: true, childList: true });

    // Scroll listener with rAF throttle
    window.addEventListener('scroll', () => {
      if (!this.ticking) {
        window.requestAnimationFrame(() => {
          this._update();
          this.ticking = false;
        });
        this.ticking = true;
      }
    }, { passive: true });

    this._update();
  }

  _isOriginalBtnVisible() {
    const rect = this.originalBtn.getBoundingClientRect();
    return rect.bottom > 0 && rect.top < window.innerHeight;
  }

  _scrolledPast25() {
    const scrollY = window.scrollY || window.pageYOffset;
    const docHeight = document.documentElement.scrollHeight - window.innerHeight;
    return docHeight > 0 && scrollY / docHeight >= 0.25;
  }

  _update() {
    const shouldShow = this._scrolledPast25() && !this._isOriginalBtnVisible();

    if (shouldShow) {
      this.el.classList.add('is-visible');
      this.el.removeAttribute('aria-hidden');
    } else {
      this.el.classList.remove('is-visible');
      this.el.setAttribute('aria-hidden', 'true');
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.sticky-atc').forEach((el) => new StickyATC(el));
});
